import { observer } from 'mobx-react';
import { FC } from 'react';
import branchEditStore from '../../store/branchEditStore';
import { DELIVERY_CONDITION } from '../../types/branchEdit';
import { BRANCH_DELIVERY_CONDITION } from 'src/types/branches';
import { TTranslate } from 'src/types/main';
import { getTranslate, getValidatedInputNumericValue } from 'src/utils/helpers';
import Input from 'src/view/components/Controls/Input/Input';
import './style.scss';

interface IProps {
  id: number;
  name: TTranslate;
  deliveryFeeValue: string;
  minimumOrderValue: string;
  minimumOrderType: BRANCH_DELIVERY_CONDITION;
  orderMoreThan: string;
  reduceDeliveryFeeValue: string;
  deliveryFeeType: BRANCH_DELIVERY_CONDITION;
  reduceDeliveryFeeType: BRANCH_DELIVERY_CONDITION;
  onChangeValueByLocation: (id: number, value: string, type: DELIVERY_CONDITION) => void;
}

const BranchZonesTableRow: FC<IProps> = observer(
  ({
    id,
    name,
    minimumOrderValue,
    minimumOrderType,
    deliveryFeeValue,
    deliveryFeeType,
    reduceDeliveryFeeValue,
    reduceDeliveryFeeType,
    orderMoreThan,
    onChangeValueByLocation,
  }): JSX.Element => {
    const onChangeValue = (value: string, type: DELIVERY_CONDITION) => {
      const validatedValue = getValidatedInputNumericValue(value);
      if (validatedValue == null) return;
      onChangeValueByLocation(id, validatedValue, type);
    };

    const isValidReducedDF = () => branchEditStore.validation.deliverySettings.reduced.areaID.some((fieldId) => fieldId === id);

    return (
      <div className="branch-zones-table-row">
        <div className="branch-zones-table-row__name-clmn">
          <p className="family-medium text-size-16 text-elipsis">{getTranslate(name)}</p>
        </div>
        {minimumOrderType === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <Input
            value={minimumOrderValue}
            className="input input-mini branch-zones-table-row__input"
            wrapperClassName="branch-zones-table-row__input-wrapper"
            onChangeText={(value) => onChangeValue(value, DELIVERY_CONDITION.MIN_ORDER)}
          />
        )}
        {deliveryFeeType === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <Input
            value={deliveryFeeValue}
            className="input input-mini branch-zones-table-row__input"
            wrapperClassName="branch-zones-table-row__input-wrapper"
            onChangeText={(value) => onChangeValue(value, DELIVERY_CONDITION.DELIVERY_FEE)}
          />
        )}
        {reduceDeliveryFeeType === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <>
            <Input
              error={isValidReducedDF()}
              showTooltip={isValidReducedDF()}
              tooltipText="reduced_df_equal_or_more_df"
              value={reduceDeliveryFeeValue}
              className="input input-mini branch-zones-table-row__input"
              wrapperClassName="branch-zones-table-row__input-wrapper"
              onChangeText={(value) => onChangeValue(value, DELIVERY_CONDITION.REDUCED_DELIVERY_FEE)}
            />
            <Input
              value={orderMoreThan}
              className="input input-mini branch-zones-table-row__input"
              wrapperClassName="branch-zones-table-row__input-wrapper"
              onChangeText={(value) => onChangeValue(value, DELIVERY_CONDITION.ORDER_MORE_THAN)}
            />
          </>
        )}
      </div>
    );
  }
);

export default BranchZonesTableRow;
